import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridNoRecords
} from "@progress/kendo-react-grid";
import { Icon } from "@iconify/react";


function CheckHistoryTable(Props: any) {


    
    const requestDate = (props: GridCellProps) => {
        return (
            <td>
                {(new Date(parseInt(props.dataItem.status_update_date))).toDateString().slice(3)}
            </td>
        )
    }
 
    const checkAction = (id: string) => {
        switch (id) {
            case '2':
                return 'Submitted'
            case '3':
                return 'Approved'
            case '4':
                return 'Rejected'
       }
   }


    const actionCell = (props: GridCellProps) => {
       
        return (
            <td>
                {checkAction(props.dataItem.status_id)}
            </td>
        )
   }

    return (
      
        <div className='tableStyle no-top-padd no-min-height tableMaxHeight'>
             <Grid
                data={Props.data}
            >
                <GridNoRecords>
                    <div className="noData">
                    <Icon icon="mdi:smiley-neutral-outline" />
                    No data to display
                    </div>
                </GridNoRecords>
                <Column field="status_update_date"  title="Date" width='250px' cell={requestDate}/>
                <Column field="action" title="Action" width='250px' cell={actionCell}/>
                <Column field="user" title="User" width='250px'/>
                <Column field="reject_comment" title="Reason"  width='250px'/>
                
            </Grid>
    </div>
  )
}

export default CheckHistoryTable